import React from "react";
import "./course.resources.cmp.scss";
import { cleanModuleTitle } from "../../../helpers/course.helper";
import { FileText, Link as LinkIcon } from "lucide-react";

const CourseResourcesCmp = ({ selected }) => {
  const cleanedTitle = cleanModuleTitle(selected?.title || "");
  const resources = Array.isArray(selected?.data) ? selected.data : [];

  return (
    <div className="course-resources marks-bg">
      <div className="resources-header">
        <h2 className="resources-title">{cleanedTitle || "Resources"}</h2>
        <p className="resources-copy">
          Open or download the supporting materials for this module.
        </p>
      </div>

      {resources.length === 0 ? (
        <div className="resources-empty">No resources available for this section.</div>
      ) : (
        <div className="resources-list">
          {resources.map((resource, index) => {
            const resourceName = resource?.name || `Resource ${index + 1}`;
            const resourceLink = resource?.link;
            const resourceType = (resource?.type || "link").toUpperCase();

            return (
              <a
                key={`${resourceName}-${index}`}
                className="resource-card"
                href={resourceLink}
                target="_blank"
                rel="noreferrer"
              >
                <div className="resource-card__icon">
                  {resource?.type === "pdf" ? <FileText size={20} /> : <LinkIcon size={20} />}
                </div>
                <div className="resource-card__content">
                  <div className="resource-card__title">{resourceName}</div>
                  <div className="resource-card__meta">{resourceType}</div>
                </div>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CourseResourcesCmp;
